import React from "react";
import BilateralGuaranteeData from "./BilateralGuaranteeDataView";
import {ColumnGroup} from "primereact/columngroup";
import {Row} from "primereact/row";
import {Column} from "primereact/column";
import {amount, decimalFormat} from "../../utils/formatters/Numbers";

export default class BilateralGuaranteeDataContainer extends React.Component {
    constructor(props) {
        super(props);
        this.setCollateralDetail = this.setCollateralDetail.bind(this);
        this.state = {
            collateralDetail:{},
            collateralAssignedList: [],
            totalAmount: 0,
            collateralPercent: 0,
        };
    }

    setCollateralDetail() {
        this.setState((prevState) => {
            let collateralDetail = prevState.collateralDetail;
            let collateralList = this.reformatCollateralAssignedList(collateralDetail.collateralDetailList);
            return{
                collateralAssignedList: collateralList,
                totalAmount: collateralDetail.totalAmount,
                collateralPercent: collateralDetail.collateralPercent,
            };
        });
    }

    reformatCollateralAssignedList(collateralList){
        return collateralList.map((collateralItem) => (
            {
                composeName: this.getNameSerialCouponStr(collateralItem.detailComposeName),
                valueType: collateralItem.detailComposeName.valueType,
                title: collateralItem.title,
                price: collateralItem.price,
                amount: collateralItem.amount,
                haircut: collateralItem.haircut,
                coveragePercent: collateralItem.coveragePercent,
                operation: collateralItem.operation
            }
        ));
    }

    getNameSerialCouponStr(detailComposeName) {
        return detailComposeName.name + " "
            + detailComposeName.serial + " "
            + detailComposeName.coupon;
    }

    render() {
        let footerColumnGroup =
            <ColumnGroup>
                <Row>
                    <Column footer="Totales:" colSpan={4} style={{textAlign: 'right'}}/>
                    <Column footer={amount(this.state.totalAmount, 'right')}/>
                    <Column footer=""/>
                    <Column footer={decimalFormat(this.state.collateralPercent, 'right', 4)}/>
                    <Column footer=""/>
                </Row>
            </ColumnGroup>;

        return <BilateralGuaranteeData
            collateralAssignedList={this.state.collateralAssignedList}
            footerColumnGroup={footerColumnGroup}
        />
    }
}

BilateralGuaranteeDataContainer.propTypes = {
};